// extracted by mini-css-extract-plugin
export default {"container":"k0-z","list":"l0-z"};